import { httpsCallable } from 'common/frontend/firebase/functions';

export interface FieldErrors {
	company?: {
		[fieldName: string]: string;
	};
	shareholders?: {
		[shareholderCode: string]: {
			[fieldName: string]: string;
		};
	};
	bankAccountDetails?: {
		[bankAccountUUID: string]: {
			[fieldName: string]: string;
		};
	};
}

export const getAdyenFieldErrors = (invalidFields: any[]): FieldErrors => {
	let errors: FieldErrors = {};
	for (const field of invalidFields) {
		const error = field.errorDescription;
		let fieldName = (field.fieldType && field.fieldType.fieldName) || '';
		if (!fieldName) {
			const fieldFullName =
				(field.fieldType && field.fieldType.field && field.fieldType.field.split('.').pop()) || '';
			fieldName = fieldFullName.charAt(0).toLowerCase() + fieldFullName.slice(1);
		}
		const shareholderCode =
			(field.fieldType && field.fieldType.shareholderCode) ||
			(field.fieldType &&
				field.fieldType.field &&
				field.fieldType.field.toLowerCase().includes('shareholders') &&
				'New') ||
			null;
		const bankAccountUUID =
			(field.fieldType && field.fieldType.bankAccountUUID) ||
			(field.fieldType &&
				field.fieldType.field &&
				field.fieldType.field.toLowerCase().includes('bankaccountdetails') &&
				'New') ||
			null;
		if (error && fieldName && shareholderCode) {
			errors = {
				...errors,
				shareholders: {
					...errors.shareholders,
					[shareholderCode]: {
						...(errors.shareholders || {})[shareholderCode],
						[fieldName]: error,
					},
				},
			};
		} else if (error && fieldName && bankAccountUUID) {
			errors = {
				...errors,
				bankAccountDetails: {
					...errors.bankAccountDetails,
					[bankAccountUUID]: {
						...(errors.bankAccountDetails || {})[bankAccountUUID],
						[fieldName]: error,
					},
				},
			};
		} else if (error && fieldName) {
			errors = {
				...errors,
				company: {
					...errors.company,
					[fieldName]: error,
				},
			};
		}
	}
	return errors;
};

export const fetchOnboardingUrl = async (
	accountHolderCode: string,
): Promise<{ hopUrl: string }> => {
	const getOnboardingUrl = httpsCallable<any, any>('getOnboardingUrl');
	const result = await getOnboardingUrl({
		accountHolderCode,
		returnUrl: window.location.href,
	});
	return { hopUrl: result.data.redirectUrl };
};
